import { render, staticRenderFns } from "./PremiumPlanCard.vue?vue&type=template&id=412ef7cb&scoped=true"
import script from "./PremiumPlanCard.vue?vue&type=script&lang=js"
export * from "./PremiumPlanCard.vue?vue&type=script&lang=js"
import style0 from "./PremiumPlanCard.vue?vue&type=style&index=0&id=412ef7cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ef7cb",
  null
  
)

export default component.exports